import { render, staticRenderFns } from "./MaterialRadioCustomList.vue?vue&type=template&id=45bab7ca&scoped=true&"
import script from "./MaterialRadioCustomList.vue?vue&type=script&lang=js&"
export * from "./MaterialRadioCustomList.vue?vue&type=script&lang=js&"
import style0 from "./MaterialRadioCustomList.vue?vue&type=style&index=0&id=45bab7ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45bab7ca",
  null
  
)

export default component.exports